import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_INVOICES } from '@/lib/constants/api'
import getInvoiceModel from './models/invoice'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import { postingResultMessage, repostResultMessage } from '@/lib/invoices'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

// A failed Posting still resolves with its result, so the caller can show the stored reason.
const sendPosting = (dispatch, { path, progressMessage, resultMessage, errorMessage }) => {
  showProgressModal({ dispatch, message: progressMessage })

  return api.doPost({ path })
    .then(json => json.data)
    .then(result => {
      const { success, message } = resultMessage(result)
      if (success) {
        notifySuccess(dispatch, message)
      } else {
        notifyError(dispatch, message)
      }
      return result
    })
    .catch(error => {
      notifyError(dispatch, error.message || errorMessage)
      return null
    })
    .finally(() => {
      hideProgressModal({ dispatch })
    })
}

const invoice = {
  namespaced: true,
  state: () => ({
    ...getInvoiceModel()
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setInvoiceDetail: (state, { invoice, lines, postingAttempts }) => {
      state.invoice = invoice || null
      state.lines = Array.isArray(lines) ? lines : []
      state.postingAttempts = Array.isArray(postingAttempts) ? postingAttempts : []
    },
    clearInvoice: (state) => {
      const initial = getInvoiceModel()
      Object.keys(initial).forEach(key => { state[key] = initial[key] })
    }
  },
  actions: {
    getInvoice: ({ commit, dispatch }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading invoice, please wait...' })

      return api.doGet({ path: `${PATH_INVOICES}/${id}` })
        .then(json => json.data)
        .then(detail => {
          commit('setInvoiceDetail', detail || {})
          commit('updateStatus', { status: COMPLETE })
          return detail
        })
        .catch(error => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load invoice')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    postInvoice: ({ dispatch }, { id }) => sendPosting(dispatch, {
      path: `${PATH_INVOICES}/${id}/post`,
      progressMessage: 'Posting to QuickBooks, please wait...',
      resultMessage: postingResultMessage,
      errorMessage: 'Unable to post invoice'
    }),
    repostInvoice: ({ dispatch }, { id }) => sendPosting(dispatch, {
      path: `${PATH_INVOICES}/${id}/repost`,
      progressMessage: 'Updating the QuickBooks invoice, please wait...',
      resultMessage: repostResultMessage,
      errorMessage: 'Unable to re-post invoice'
    }),
    clearInvoice: ({ commit }) => commit('clearInvoice')
  }
}

export default invoice
